var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClockTimeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 10,
    fill: "#EFFFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 16.9534C21.1818 17.837 22 18.2789 22 19C22 19.7211 21.1818 20.163 19.5454 21.0466L18.4311 21.6484C17.1744 22.327 16.5461 22.6663 16.2439 22.4196C15.504 21.8154 16.6567 20.2561 16.9403 19.7037C17.2277 19.144 17.2225 18.8459 16.9403 18.2963C16.6567 17.7439 15.504 16.1846 16.2439 15.5804C16.5461 15.3337 17.1744 15.673 18.4311 16.3516L19.5454 16.9534Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5V12.5L13.5 14",
    stroke: "#30BD6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 16.9534C21.1818 17.837 22 18.2789 22 19C22 19.7211 21.1818 20.163 19.5454 21.0466L18.4311 21.6484C17.1744 22.327 16.5461 22.6663 16.2439 22.4196C15.504 21.8154 16.6567 20.2561 16.9403 19.7037C17.2277 19.144 17.2225 18.8459 16.9403 18.2963C16.6567 17.7439 15.504 16.1846 16.2439 15.5804C16.5461 15.3337 17.1744 15.673 18.4311 16.3516L19.5454 16.9534Z",
    stroke: "#30BD6F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0261 22.448C12.6888 22.4824 12.3464 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 13.1849 21.9311 13.8538 21.8 14.5",
    stroke: "#30BD6F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockTimeLeft);
export default __webpack_public_path__ + "static/media/ic_clock_time_left.41e5ea048bbbb3dea94f1729a2436c39.svg";
export { ForwardRef as ReactComponent };